<template>
  <div class="plan">
    <div
      class="floor-plan"
    >
      <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 1443 885" style="enable-background:new 0 0 1443 885;" xml:space="preserve"
      >
        <g>
          <g>
            <defs>
              <rect id="SVGID_1_" x="-0.3" y="0.6" width="1442.9" height="884.5"/>
            </defs>
            <clipPath id="SVGID_2_">
              <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
            </clipPath>
            <g class="st0">
              <defs>
                <rect id="SVGID_3_" x="-0.3" y="0.6" width="1442.9" height="884.5"/>
              </defs>
              <clipPath id="SVGID_4_">
                <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st1">
                <g>
                  <defs>
                    <rect id="SVGID_5_" x="4.7" y="10.1" width="1441.1" height="864.6"/>
                  </defs>
                  <clipPath id="SVGID_6_">
                    <use xlink:href="#SVGID_5_"  style="overflow:visible;"/>
                  </clipPath>
                  <polygon class="st2" points="1436.8,605.5 803,605.5 803,626 703.7,626 703.7,17.1 13.7,17.1 13.7,873.7 703.7,873.7 
                    703.7,864.1 806.9,864.1 806.9,863.6 1436.8,863.6 					"/>
                </g>
              </g>
              <g class="st3">
                <g>
                  <defs>
                    <rect id="SVGID_7_" x="254.2" y="242" width="80.8" height="74.9"/>
                  </defs>
                  <clipPath id="SVGID_8_">
                    <use xlink:href="#SVGID_7_"  style="overflow:visible;"/>
                  </clipPath>
                  <path class="st4" d="M326,249h-51.2v18l-10.6,10.6c-1.3,1.3-1.3,3.4,0,4.8l32.5,32.5c1.3,1.3,3.5,1.3,4.8,0l12.4-12.3H326
                    L326,249z"/>
                </g>
              </g>
              <g class="st3">
                <g>
                  <defs>
                    <rect id="SVGID_9_" x="255.1" y="788.3" width="84.9" height="70.8"/>
                  </defs>
                  <clipPath id="SVGID_10_">
                    <use xlink:href="#SVGID_9_"  style="overflow:visible;"/>
                  </clipPath>
                  <path class="st5" d="M331,859v-52.2h-18l-10.6-10.6c-1.3-1.3-3.4-1.3-4.8,0l-32.6,32.5c-1.3,1.3-1.3,3.5,0,4.8l12.4,12.4v13.1
                    L331,859z"/>
                </g>
              </g>
              <g class="st3">
                <g>
                  <defs>
                    <rect id="SVGID_11_" x="338.1" y="786.2" width="80.8" height="74.9"/>
                  </defs>
                  <clipPath id="SVGID_12_">
                    <use xlink:href="#SVGID_11_"  style="overflow:visible;"/>
                  </clipPath>
                  <path class="st6" d="M347.2,860.1h51.1v-17.9l10.6-10.6c1.3-1.3,1.3-3.5,0-4.8l-32.6-32.5c-1.3-1.3-3.4-1.3-4.8,0l-12.4,12.3
                    h-12.1L347.2,860.1z"/>
                </g>
              </g>
              <g class="st3">
                <g>
                  <defs>
                    <rect id="SVGID_13_" x="1302.7" y="660.3" width="132.7" height="198.8"/>
                  </defs>
                  <clipPath id="SVGID_14_">
                    <use xlink:href="#SVGID_13_"  style="overflow:visible;"/>
                  </clipPath>
                  <rect x="1311.7" y="669.3" class="st7" width="114.7" height="190.8"/>
                </g>
              </g>
              <g class="st3">
                <g>
                  <defs>
                    <rect id="SVGID_15_" x="796.7" y="606.3" width="243" height="187.3"/>
                  </defs>
                  <clipPath id="SVGID_16_">
                    <use xlink:href="#SVGID_15_"  style="overflow:visible;"/>
                  </clipPath>
                  <rect x="805.7" y="614.3" class="st8" width="225" height="179.4"/>
                </g>
              </g>
              <g class="st3">
                <g>
                  <defs>
                    <rect id="SVGID_17_" x="430.3" y="238" width="269" height="137.6"/>
                  </defs>
                  <clipPath id="SVGID_18_">
                    <use xlink:href="#SVGID_17_"  style="overflow:visible;"/>
                  </clipPath>
                  <rect x="438.3" y="245" class="st9" width="251" height="129.6"/>
                </g>
              </g>
              <path class="st10" d="M1422.4,660.7h-105.6v-11h-19.3v155.8h4.4v52.8h-185.6v-15.2h-9.9v15.2H812.8v-14h-14.3v14h-88v-20.6h-30.2
                v20.6H352v-80.1h-28.1v80.1H37.9v-41.8h-4.5v-51.5h4.5v-54.6h-4.5v-50.8h4.5v-54.1h-4.5v-52h4.5v-36.5h119v-15h-119v-35.3h-4.5
                v-49.7h4.5V330h-4.5v-50h4.5v-25.6h119v-15h-119v-18.8h-4.5v-47.5h4.5V113h-4.5V66.3h4.5V29h285.9v153.5H352V29h331.8v22.3h4.8
                V112h-5.1v43.4H399.2v15.4H416v24.5h20.9v-13h45.6v-11.5h200.9v11h5.2v32.2h-5.2v26.4H439v-11.1h-23V262h23v-11.7h244.4v29.5h5.2
                v59.7h-5.2v33.9H478.2v-33.9H439v-41.2h-23v165.3h23v-80.1h244.4v32h5.2v61.1h-5.2v33.9H439v-9.1h-23v9.1h-7.2V531h16.5v27.6H439
                V531h244.4v103.1l-15.6,15.9H440v-33.6h-14.8v33.6h-16.5v20.5h34.5v17h41.9v-9.8h78.3v-7.2h114.8v-0.1h2.8l29.8-29.6v-4.4h81.7
                v6.2h6v159.9H916v-9.9H812.8V619.9h36.8l-0.5-4.6h55.7v5.4h51v-5.4h58v5.4h16.8v171.9h-71.8v9.9h110v-9.9h-11.3v-51.4h-16.7
                V620.8h24v-5.4h51.2l-9.7,7v180.4h9.8v-171l16-11.1h51.1v-5.2h61v5.2h89.7v-5.2h69.8v5.5h18.5L1422.4,660.7L1422.4,660.7z
                M1422.4,798.9h-52.5v59.4h-53.1V671.2h105.7L1422.4,798.9z M31.5,113h-5v-6H14.3V72.4h11.9v-6.2h5.2V113z M31.5,220.6h-5v-6.7
                H14.3v-34.5h12.1v-6.3h5V220.6z M31.5,330h-5v-6.7H14.3v-36.8h12.1v-6.7h5V330z M31.5,466.6h-5v-7.1H14.3v-36.4h12.1v-6.3h5
                V466.6z M31.5,605.3h-5v-6.7H14.3v-38.2h12.1v-7h5V605.3z M31.5,710.3h-5V704H14.3v-37.5h12.1v-7h5V710.3z M31.5,816.4h-5v-6.7
                H14.3v-38.2h12.1v-6.7h5V816.4z M690.6,415.4h5v6.6h6.5v48.6h-6.5v5.9h-5V415.4z M690.6,279.8h5v7.2h6.5v46.1h-6.5v6.5h-5V279.8z
                M690.6,181.8h5v4.5h6.5v22.8h-6.5v5h-5V181.8z M690.6,51.3h5v7.3h6.5v45.5h-6.5v8h-5V51.3z M710.9,628.9v-2.5h81.7v8h-81.7
                V628.9z M853.8,611.9v-6.2h45.8v5.8h5.2v1.8h-55.9l-0.1-1L853.8,611.9z M955.8,611.5h4.9v-5.8h46.3v5.8h6.8v1.8h-58V611.5z
                M1064.8,611.5h6.9v-5.8h46.2v7.5h-53.1V611.5z M1183.4,611.5h9.9v-5.8h45.6v5.8h5.5v1.8h-61V611.5z M1334.1,611.5h4.7v-5.8h60.6
                v5.8h4.6v1.8h-69.8V611.5z M1399.3,597v5.8h-60.6V597h-99.8v5.8h-45.7V597h-75.3v5.8h-46.2V597H1007v5.8h-46.3V597h-61.2v5.8
                h-45.8v-5.6h-41.2c0,0-13.2,1-14.1,13.8c-0.2,2.5-0.3,4.2-0.4,5.4l-5.6,0.1v7h-81.7V470.6H705V422h5.8v-88.9H705v-46.1h5.8v-77.9
                H705v-22.8h5.8v-82.2H705V58.7h5.8V0.6h-15.3v0.1H-0.3v71.8h11.7v34.6H-0.3v72.4h11.7v34.5H-0.3v72.7h11.7v36.8H-0.3v99.8h11.7
                v36.4H-0.3v100.9h11.7v38.2H-0.3v67.9h11.7V704H-0.3v67.5h11.7v38.2H-0.3V885h34.8v0.1h1407.8v-10.1h0.3v-278"/>
            </g>
            <polygon class="st11" points="323.9,354.3 352,354.3 352,225.9 323.9,225.9 323.9,239.3 210.8,239.3 210.8,254.3 323.9,254.3 		
              "/>
            <polygon class="st11" points="352,407.4 323.9,407.4 323.9,501.8 210.8,501.8 210.8,516.8 323.9,516.8 323.9,727.2 352,727.2 
              352,670.5 356.8,670.5 356.8,649.9 352,649.9 		"/>
            <g class="st0">
              <defs>
                <rect id="SVGID_19_" x="-0.3" y="0.6" width="1442.9" height="884.5"/>
              </defs>
              <clipPath id="SVGID_20_">
                <use xlink:href="#SVGID_19_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st12">
                <g>
                  <defs>
                    <rect id="SVGID_21_" x="428.7" y="523.7" width="265" height="128"/>
                  </defs>
                  <clipPath id="SVGID_22_">
                    <use xlink:href="#SVGID_21_"  style="overflow:visible;"/>
                  </clipPath>
                  <polyline class="st13" points="438.7,530.7 439.7,650.7 669.6,650.7 684.7,634.7 684.7,530.7 					"/>
                </g>
              </g>
            </g>
          </g>
          <g>
            <defs>
              <rect id="SVGID_23_" x="394.8" y="526.4" width="222.6" height="125.2"/>
            </defs>
            <clipPath id="SVGID_24_">
              <use xlink:href="#SVGID_23_"  style="overflow:visible;"/>
            </clipPath>
            <line class="st14" x1="396.6" y1="588.3" x2="502.1" y2="588.3"/>
            <line class="st14" x1="395.9" y1="588.2" x2="422.3" y2="577.6"/>
            <line class="st14" x1="395.9" y1="588.3" x2="422.3" y2="598.9"/>
            <path class="st15" d="M582.2,588.4v62.2 M568.2,588.4v62.2 M555.2,588.4v62.2 M542.2,588.4v62.2 M529.2,588.4v62.2 M516.2,588.4
              v62.2 M504.2,588.4v62.2 M490.7,588.4v62.2 M477.4,588.4h118.5v62.2H477.4V588.4z M602.7,527.4v60.7 M588.7,527.4v60.7
              M575.7,527.4v60.7 M562.7,527.4v60.7 M549.7,527.4v60.7 M536.7,527.4v60.7 M524.7,527.4v60.7 M511.2,527.4v60.7 M497.9,527.4
              h118.5v60.7H497.9V527.4z"/>
          </g>
        </g>
        <g>
          <defs>
            <rect id="SVGID_25_" x="462.2" y="529.5" width="297.8" height="160.2"/>
          </defs>
          <clipPath id="SVGID_26_">
            <use xlink:href="#SVGID_25_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <defs>
              <rect id="SVGID_27_" x="462.2" y="529.5" width="297.8" height="160.2"/>
            </defs>
            <clipPath id="SVGID_28_">
              <use xlink:href="#SVGID_27_"  style="overflow:visible;"/>
            </clipPath>
            <g class="st17">
              <g>
                <defs>
                  <rect id="SVGID_29_" x="462.2" y="529.5" width="297.8" height="160.2"/>
                </defs>
                <clipPath id="SVGID_30_">
                  <use xlink:href="#SVGID_29_"  style="overflow:visible;"/>
                </clipPath>
                <path class="st18" d="M631.6,596.5c-0.8,0.4-1.5,0.6-2.1,0.6c-1.1,0-2-0.4-2.5-1.2c-0.6-0.8-0.8-2-0.8-3.7c0-2.6,0.5-4.6,1.5-6
                  c1-1.4,2.2-2.1,3.6-2.1c1.2,0,2.1,0.5,2.7,1.5c0.6,1,0.8,2.3,0.8,4c0,0.9-0.1,1.8-0.4,2.7c-0.2,0.9-0.5,1.7-0.9,2.6
                  C633,595.5,632.4,596,631.6,596.5 M638,581c-1.1,0.1-2.7,0.2-4.8,0.2c-1.4,0-2.7,0.4-3.9,1.2c-1.2,0.8-2.2,1.9-3,3.2
                  c-0.9,1.3-1.5,2.7-2,4.1c-0.5,1.5-0.7,2.8-0.7,4.1c0,3.8,1.5,5.7,4.4,5.7c0.6,0,1.3-0.3,2.2-0.8c0.9-0.5,1.6-1.2,2.3-1.9
                  c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.2-0.3,0.4-0.4,0.7c-1.1,1.9-1.7,3.7-1.8,5.5c-0.1,1.7,0.3,3.6,1.5,5.5
                  c0.8,1.4,1.5,2.6,1.9,3.6c0.4,1.1,0.6,2.3,0.6,3.6c0,2.3-0.7,4.2-2,5.6c-1.4,1.5-3.5,2.2-6.3,2.2c-3.4,0-6.1-0.9-8.2-2.8
                  c-2.1-1.8-3.1-4.3-3.1-7.3c0-1.6,0.4-2.9,1.2-3.8c0.8-0.9,1.8-1.7,3-2.1c0.2-0.2,0.2-0.4,0.1-0.6c-0.1-0.2-0.3-0.3-0.6-0.3
                  c-2.4,0.7-4.2,1.6-5.5,3c-1.3,1.3-1.9,2.9-1.9,4.7c0,1.4,0.3,2.7,0.9,4c0.6,1.3,1.5,2.4,2.6,3.4s2.6,1.8,4.2,2.4
                  c1.7,0.6,3.5,0.9,5.6,0.9c2,0,3.8-0.3,5.4-0.8c1.6-0.6,3-1.3,4.1-2.3c1.1-1,2-2.1,2.6-3.4c0.6-1.3,0.9-2.6,0.9-4
                  c0-0.9-0.1-1.7-0.2-2.5c-0.1-0.8-0.4-1.5-0.7-2.3c-0.3-0.7-0.7-1.5-1.2-2.3c-0.4-0.8-0.9-1.7-1.5-2.7c-0.7-1.2-1-2.3-1-3.2
                  c0-1,0.1-1.9,0.4-2.9c0.3-0.9,0.8-1.9,1.3-2.8c0.6-0.9,1.1-1.8,1.6-2.8c0.5-1,1-2.1,1.4-3.2c0.4-1.1,0.6-2.4,0.6-3.7
                  c0-1.4-0.3-2.6-0.8-3.5c1.1,0.1,2-0.2,2.7-0.8c0.7-0.6,1.3-1.2,1.8-1.9c0.1-0.2,0.1-0.4-0.1-0.6c-0.2-0.1-0.4-0.2-0.5,0
                  C640,580.5,639.1,580.9,638,581 M615.6,601.3c-0.9,0-1.4-0.7-1.4-2.2c0-2.1,0.4-4.3,1.3-6.8c0.9-2.5,1.9-4.8,3.2-7.1
                  c0.4-0.8,0.5-1.5,0.5-2.3c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.4-0.9-0.5-1.6-0.5c-1.1,0-2.2,0.3-3.4,0.9c-1.2,0.6-2.4,1.4-3.6,2.4
                  c-1.2,1-2.4,2.2-3.5,3.6c-1.1,1.4-2.1,2.9-2.9,4.5c0.5-1.4,0.9-2.9,1.3-4.3c0.4-1.5,0.7-2.8,1-4.1c0.5-2,0-3-1.5-3
                  c-1.3,0-2.5,0.5-3.6,1.6c-1.1,1.1-2,2.1-2.7,3.1c-0.1,0.2,0,0.4,0.1,0.5c0.1,0.2,0.3,0.2,0.4,0.1c0.7-0.9,1.3-1.7,1.9-2.3
                  c0.6-0.6,1.2-0.9,1.8-0.9c0.7,0,0.9,0.6,0.6,1.7c-0.8,3.1-1.8,6.3-2.9,9.5c-1.1,3.2-2.1,6.1-3.2,8.6c-0.2,0.5,0.1,0.8,0.7,0.8
                  c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1-0.8c2.3-6.5,4.7-11.2,7.3-14.2c2.6-3,5.1-4.5,7.2-4.5c0.6,0,0.9,0.3,0.9,1
                  c0,0.4-0.1,0.8-0.4,1.2c-1.2,2.5-2.2,5-2.9,7.4c-0.7,2.5-1.1,4.7-1.1,6.7c0,2.4,0.9,3.6,2.8,3.6c1.1,0,2.2-0.5,3.4-1.6
                  c1.2-1,2.3-2.2,3.3-3.6c0.1-0.2,0-0.4-0.2-0.5c-0.2-0.1-0.4-0.1-0.5,0C618.2,600.3,616.8,601.3,615.6,601.3 M575.4,599.6
                  c-0.4-0.9-0.7-1.9-0.7-3.2c0-2,0.3-3.9,0.8-5.5c0.5-1.7,1.2-3.1,2.1-4.3c0.9-1.2,1.9-2.2,3.1-2.8c1.2-0.7,2.4-1,3.7-1
                  c1.1,0,2.1,0.2,3,0.7c0.9,0.5,1.4,1.1,1.6,1.9c-0.8,1.9-1.8,3.8-2.9,5.6c-1.1,1.9-2.2,3.5-3.3,5c-1.1,1.5-2.2,2.7-3.2,3.6
                  c-1,0.9-1.9,1.4-2.5,1.4C576.4,600.9,575.9,600.5,575.4,599.6 M589.5,601.3c-0.8,0.4-1.3,0.4-1.6,0c-0.4-0.5-0.5-1.5-0.3-3
                  c0.1-1.5,0.5-3.1,1-5c0.5-1.9,1.3-3.9,2.3-5.9c1-2,2.1-3.9,3.5-5.5c0.1-0.3,0-0.4-0.3-0.4c-0.5,0-1.1,0.1-1.7,0.4
                  c-0.6,0.3-1.1,0.5-1.5,0.8c-0.7-0.5-1.4-0.8-2.1-1.1c-0.8-0.2-1.7-0.4-2.8-0.4c-2,0-3.8,0.5-5.6,1.4c-1.8,0.9-3.3,2.2-4.7,3.8
                  c-1.4,1.6-2.4,3.3-3.2,5.2c-0.8,1.9-1.2,3.9-1.2,5.8c0,2.2,0.4,3.8,1.1,4.8c0.7,1,1.6,1.6,2.7,1.6c1.7-0.4,3.4-1.4,5.2-3.2
                  c1.8-1.8,3.5-4,5.1-6.4c-0.4,1.2-0.6,2.4-0.8,3.6c-0.1,1.2-0.2,2.2-0.1,3.1c0.1,0.9,0.3,1.6,0.6,2.2c0.3,0.5,0.8,0.8,1.3,0.8
                  c0.8,0,1.9-0.4,3.1-1.2c1.2-0.8,2.4-2.1,3.7-3.8c0.1-0.2,0-0.4-0.2-0.5c-0.2-0.1-0.3-0.1-0.4,0
                  C591.3,599.9,590.3,600.9,589.5,601.3 M561,596.5c-0.8,0.4-1.5,0.6-2.1,0.6c-1.1,0-2-0.4-2.5-1.2c-0.6-0.8-0.8-2-0.8-3.7
                  c0-2.6,0.5-4.6,1.5-6c1-1.4,2.2-2.1,3.6-2.1c1.2,0,2.1,0.5,2.7,1.5c0.6,1,0.8,2.3,0.8,4c0,0.9-0.1,1.8-0.4,2.7
                  c-0.2,0.9-0.5,1.7-0.9,2.6C562.4,595.5,561.8,596,561,596.5 M567.3,581c-1.1,0.1-2.7,0.2-4.8,0.2c-1.4,0-2.7,0.4-3.9,1.2
                  c-1.2,0.8-2.2,1.9-3,3.2c-0.9,1.3-1.5,2.7-2,4.1c-0.5,1.5-0.7,2.8-0.7,4.1c0,3.8,1.5,5.7,4.4,5.7c0.6,0,1.3-0.3,2.2-0.8
                  c0.9-0.5,1.6-1.2,2.3-1.9c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.2-0.3,0.4-0.4,0.7c-1.1,1.9-1.7,3.7-1.8,5.5
                  c-0.1,1.7,0.3,3.6,1.5,5.5c0.8,1.4,1.5,2.6,1.9,3.6c0.4,1.1,0.6,2.3,0.6,3.6c0,2.3-0.7,4.2-2,5.6c-1.4,1.5-3.5,2.2-6.3,2.2
                  c-3.4,0-6.1-0.9-8.2-2.8c-2.1-1.8-3.1-4.3-3.1-7.3c0-1.6,0.4-2.9,1.2-3.8c0.8-0.9,1.8-1.7,3-2.1c0.2-0.2,0.2-0.4,0.1-0.6
                  c-0.1-0.2-0.3-0.3-0.6-0.3c-2.4,0.7-4.2,1.6-5.5,3c-1.3,1.3-1.9,2.9-1.9,4.7c0,1.4,0.3,2.7,0.9,4c0.6,1.3,1.5,2.4,2.6,3.4
                  s2.6,1.8,4.2,2.4c1.7,0.6,3.5,0.9,5.6,0.9c2,0,3.8-0.3,5.4-0.8c1.6-0.6,3-1.3,4.1-2.3c1.1-1,2-2.1,2.6-3.4
                  c0.6-1.3,0.9-2.6,0.9-4c0-0.9-0.1-1.7-0.2-2.5c-0.1-0.8-0.4-1.5-0.7-2.3c-0.3-0.7-0.7-1.5-1.2-2.3c-0.4-0.8-0.9-1.7-1.5-2.7
                  c-0.7-1.2-1-2.3-1-3.2c0-1,0.1-1.9,0.4-2.9c0.3-0.9,0.8-1.9,1.3-2.8c0.6-0.9,1.1-1.8,1.6-2.8c0.5-1,1-2.1,1.4-3.2
                  c0.4-1.1,0.6-2.4,0.6-3.7c0-1.4-0.3-2.6-0.8-3.5c1.1,0.1,2-0.2,2.7-0.8c0.7-0.6,1.3-1.2,1.8-1.9c0.1-0.2,0.1-0.4-0.1-0.6
                  c-0.2-0.1-0.4-0.2-0.5,0C569.3,580.5,568.4,580.9,567.3,581 M544.9,601.3c-0.9,0-1.4-0.7-1.4-2.2c0-2.1,0.4-4.3,1.3-6.8
                  c0.9-2.5,1.9-4.8,3.2-7.1c0.4-0.8,0.5-1.5,0.5-2.3c0-0.5-0.2-0.9-0.6-1.2c-0.4-0.4-0.9-0.5-1.6-0.5c-1.1,0-2.2,0.3-3.4,0.9
                  c-1.2,0.6-2.4,1.4-3.6,2.4c-1.2,1-2.4,2.2-3.5,3.6c-1.1,1.4-2.1,2.9-2.9,4.5c0.5-1.4,0.9-2.9,1.3-4.3c0.4-1.5,0.7-2.8,1-4.1
                  c0.5-2,0-3-1.5-3c-1.3,0-2.5,0.5-3.6,1.6c-1.1,1.1-2,2.1-2.7,3.1c-0.1,0.2,0,0.4,0.1,0.5c0.1,0.2,0.3,0.2,0.4,0.1
                  c0.7-0.9,1.3-1.7,1.9-2.3c0.6-0.6,1.2-0.9,1.8-0.9c0.7,0,0.9,0.6,0.6,1.7c-0.8,3.1-1.8,6.3-2.9,9.5c-1.1,3.2-2.1,6.1-3.2,8.6
                  c-0.2,0.5,0.1,0.8,0.7,0.8c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1-0.8c2.3-6.5,4.7-11.2,7.3-14.2c2.6-3,5.1-4.5,7.2-4.5
                  c0.6,0,0.9,0.3,0.9,1c0,0.4-0.1,0.8-0.4,1.2c-1.2,2.5-2.2,5-2.9,7.4c-0.7,2.5-1.1,4.7-1.1,6.7c0,2.4,0.9,3.6,2.8,3.6
                  c1.1,0,2.2-0.5,3.4-1.6c1.2-1,2.3-2.2,3.3-3.6c0.1-0.2,0-0.4-0.2-0.5c-0.2-0.1-0.4-0.1-0.5,0
                  C547.5,600.3,546.1,601.3,544.9,601.3 M526.3,572.7c1.1-1.6,2.3-2.9,3.6-4c0.1-0.1,0.1-0.3-0.1-0.4c-0.2-0.1-0.4-0.2-0.5-0.1
                  c-2.8,2.4-4.9,4.7-6.5,6.8c-0.2,0.2-0.3,0.5-0.3,0.9c0,0.4,0,0.7,0.1,0.9c0.1,0.3,0.2,0.5,0.3,0.6c0.1,0.1,0.3,0.1,0.5,0
                  C524.2,575.8,525.2,574.3,526.3,572.7 M517.6,585.6c1-0.7,1.8-1.3,2.4-1.8c-0.7,1.1-1.4,2.3-2.2,3.8c-0.7,1.5-1.4,3-2,4.6
                  c-0.6,1.6-1.1,3.2-1.5,4.8c-0.4,1.6-0.6,2.9-0.6,4c0,2,0.8,2.9,2.3,2.9c1.1,0,2.2-0.5,3.4-1.6c1.2-1.1,2.4-2.3,3.4-3.6
                  c0.1-0.2,0.1-0.4-0.1-0.6c-0.2-0.2-0.3-0.2-0.4-0.1c-0.8,0.9-1.6,1.7-2.2,2.3c-0.6,0.6-1.3,0.8-1.9,0.8c-0.8,0-1.2-0.6-1.2-1.9
                  c0-0.9,0.2-2.1,0.5-3.6c0.4-1.5,0.8-3,1.4-4.5c0.6-1.6,1.2-3.2,2-4.8c0.7-1.6,1.5-3.1,2.3-4.4c0-0.5-0.2-0.8-0.7-0.8
                  c-1.4,0.7-2.8,1.6-4.3,2.7c-1.4,1.1-2.5,2-3.4,2.8c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.3,0.3,0.5,0.1
                  C515.9,586.9,516.6,586.3,517.6,585.6 M491.5,554.1c0.5-1.1,1.2-2.1,2.2-3s2.2-1.6,3.6-2.1c1.4-0.5,3.1-0.8,5.1-0.8
                  c2.4,0,4.5,0.5,6.3,1.6c1.8,1.1,3.1,2.1,3.7,3.2c0.5,0.8,0.6,1.6,0.4,2.4c-0.2,0.8-0.4,1.5-0.8,2.2c-0.1,0.2,0,0.4,0.2,0.5
                  c0.2,0.1,0.4,0.1,0.5,0c0.2-0.2,0.4-0.6,0.8-1.2c0.3-0.6,0.6-1.2,0.9-1.8c0.3-0.7,0.5-1.3,0.7-1.9c0.2-0.6,0.3-1.2,0.3-1.6
                  c0-0.6-0.3-1.2-0.9-1.7c-0.6-0.6-1.5-1.1-2.5-1.5c-1.1-0.4-2.3-0.8-3.6-1.1c-1.4-0.3-2.8-0.4-4.2-0.4c-2.4,0-4.7,0.4-6.7,1.1
                  s-3.8,1.6-5.3,2.8c-1.5,1.2-2.7,2.5-3.6,4c-0.9,1.5-1.3,3.1-1.3,4.8c0,1.6,0.5,3.1,1.6,4.4c1.1,1.4,2.5,2.5,4.4,3.6
                  c-3.1,0.5-5.9,1.5-8.5,2.8c-2.6,1.4-4.8,3-6.7,5c-1.9,2-3.3,4.2-4.4,6.7c-1,2.5-1.6,5.2-1.6,8c0,1.8,0.3,3.6,1,5.3
                  c0.7,1.7,1.7,3.2,3,4.5c1.3,1.3,2.9,2.3,4.8,3.1c1.9,0.8,4.1,1.2,6.6,1.2c3,0,6-0.3,8.9-1c2.9-0.7,5.4-1.5,7.5-2.4
                  c0.8-0.4,1.7-1.6,2.7-3.8c1-2.2,1.8-4.9,2.5-8.3c-0.1-0.4-0.2-0.6-0.4-0.7c-0.2-0.1-0.4,0-0.6,0.3c-1.4,5-3.6,8.7-6.7,10.9
                  c-3.1,2.3-7.1,3.4-11.9,3.4c-2.1,0-3.9-0.4-5.6-1.1c-1.6-0.7-3-1.8-4.2-3.1c-1.2-1.3-2-2.8-2.7-4.6c-0.6-1.8-0.9-3.7-0.9-5.8
                  c0-6.4,1.8-11.2,5.5-14.4c3.7-3.2,8.8-4.6,15.5-4.3c0.2-0.1,0.5-0.2,0.9-0.4c0.4-0.2,0.7-0.5,1-0.8c0.3-0.3,0.5-0.6,0.7-0.8
                  c0.1-0.3,0.1-0.5,0-0.6c-3.4-1-5.8-2.2-7.2-3.7c-1.4-1.5-2.1-3.2-2.1-5.3C490.8,556.3,491,555.2,491.5,554.1"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <!-- <div
        v-for="(marker, index) in markers"
        :key="`marker-${index}`"
        :style="`top: ${marker.y}%; left: ${marker.x}%`"
        class="marker-icon"
      >
        <img 
          :src="`../img/${marker.icon}`"
          class="clickable marker-icon-img"
          @click="previewPanorama(index + 1)"
          :id="`icon-${index + 1}`"
        >
      </div> -->
      <div 
        class="marker-icon clickable"
        @click="previewPanorama(3)"
        :style="roomPos(3)"
      >
        <img
          :src="`/svg/herrenzimmer-${roomMarker(3)}.svg`"
          class="room-marker"
          :style="markerSize(3)"
        >
      </div>
      <div 
        class="marker-icon clickable"
        @click="previewPanorama(2)"
        :style="roomPos(2)"
      >
        <img
          :src="`/svg/salon-${roomMarker(2)}.svg`"
          class="room-marker"
          :style="markerSize(2)"
        >
      </div>
      <div 
        class="marker-icon clickable"
        @click="previewPanorama(1)"
        :style="roomPos(1)"
      >
        <img
          :src="`/svg/berliner-zimmer-${roomMarker(1)}.svg`"
          class="room-marker"
          :style="markerSize(1)"
        >
      </div>
      <Preview />
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Preview from '@/components/Panorama-preview'


export default {
  name: 'plan',
  components: {
      Preview
  },
  props: {
    
  },
  data () {
      return {
          
     markers: [

        {
            x: 38,
            y: 88,
            icon: 'auge.png'
        },
        {
          x: 12,
          y: 80,
          icon: 'auge.png'
        },
        {
          x: 12,
          y: 45,
          icon: 'marker-herrenzimmer.svg'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
        rooms: 'getRoomsData',
        markedVideo: 'getMarkedVideo',
        selected: 'getSelectedRoom'
    })
  },
  methods: {
    previewPanorama(nr) {
      const selectedRoom = this.rooms.find(r => r.orderNumber === nr.toString())
      this.$store.dispatch('selectRoom', selectedRoom)
    },
    markHoveredVideo() {
      const videoId = `#icon-${this.markedVideo}`
      document.querySelectorAll('.marker-icon-img').forEach(i => {
        i.classList.remove('active')
      })
      const activeIcon = document.querySelector(videoId)
      if (activeIcon) activeIcon.classList.add('active')
    },
    markSelectedVideo() {
      const videoId = this.selected ? `#icon-${this.selected.orderNumber}` : null
      document.querySelectorAll('.marker-icon-img').forEach(i => {
        i.classList.remove('selected')
      })
      const selectedIcon = document.querySelector(videoId)
      if (selectedIcon) selectedIcon.classList.add('selected')
    },
    roomMarker (nr) {
      // console.log('selected, nr', this.selected, nr)
      return this.selected && this.selected.orderNumber === nr.toString()
        ? '02'
        : '01'
    },
    roomPos (nr) {
      let pos = {
        x: 0,
        y: 0
      }
      if(nr === 1) {
        pos.x = 24.31,
        pos.y = 71.84
      }
      if(nr === 2) {
        pos.x = 2.22,
        pos.y = 58.24
      }
      if(nr === 3) {
        pos.x = 2.22,
        pos.y = 28.685
      }
    return `width: 100%; left: ${pos.x}%; top: ${pos.y}%`
    },
    markerSize (nr) {
      let size = 100
      if(nr === 1) {
        size = 31.14
      }
      if(nr === 2) {
        size = 20.34
      }
      if(nr === 3) {
        size = 20.25
      }
      return `width: ${size}%;`
    }
    
  },
  watch: {
    markedVideo: function () {
      this.markHoveredVideo()
    },
    selected: function () {
      this.markSelectedVideo()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '@/scss/custom.scss';
    .marker {
      cursor: pointer;
    }
    .floor-plan {
      position: relative;
      width: 75vw;
    }
    .marker-icon {
      position: absolute;
      top: 0;
      left: 0;
      // img {
      //   display: block;
      //   max-width: 4rem;
      //   opacity: .65;
      //   position: relative;
      //   left: -50%;
      //   margin-top: -50%;
      //   &.active,
      //   &.selected {
      //     opacity: 1;
      //   }
      // }
      .room-marker {
        display: block;
        // width: 20.25%;
      }
    }
    /* Geiselmann-SVG */
    .st0{clip-path:url(#SVGID_2_);}
    .st1{opacity:0.5;clip-path:url(#SVGID_4_);}
    .st2{clip-path:url(#SVGID_6_);fill:#E9E2D8;}
    .st3{opacity:0.8;clip-path:url(#SVGID_4_);}
    .st4{clip-path:url(#SVGID_8_);fill:#53493F;}
    .st5{clip-path:url(#SVGID_10_);fill:#53493F;}
    .st6{clip-path:url(#SVGID_12_);fill:#53493F;}
    .st7{clip-path:url(#SVGID_14_);fill:#53493F;}
    .st8{clip-path:url(#SVGID_16_);fill:#53493F;}
    .st9{clip-path:url(#SVGID_18_);fill:#53493F;}
    .st10{clip-path:url(#SVGID_4_);fill:#53493F;}
    .st11{clip-path:url(#SVGID_2_);fill:#53493F;}
    .st12{opacity:0.8;clip-path:url(#SVGID_20_);}
    .st13{clip-path:url(#SVGID_22_);fill:#53493F;}
    .st14{clip-path:url(#SVGID_24_);fill:none;stroke:#53493F;stroke-width:2.27;stroke-linecap:round;}
    .st15{clip-path:url(#SVGID_24_);fill:none;stroke:#53493F;stroke-width:2;stroke-miterlimit:10;}
    .st16{clip-path:url(#SVGID_26_);}
    .st17{opacity:0.85;clip-path:url(#SVGID_28_);}
    .st18{clip-path:url(#SVGID_30_);fill:#DBCFBF;}
</style>
